<template>
  <div
    v-if="loading"
    style="
      border: 1px dashed var(--gray-4);
      border-radius: 8px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--gray-2);
    "
  >
    <AwIcon name="i-ph-circle-notch" class="animate-spin" />
  </div>
  <div v-else>
    <div
      v-if="contacts.length > 0"
      style="
        border: 1px solid var(--gray-5);
        border-radius: 8px;
        box-shadow:
          0 1px 3px 0 rgba(0, 0, 0, 0.1),
          0 1px 2px -1px rgba(0, 0, 0, 0.1);
      "
    >
      <div
        v-for="(contact, index) of displayedContacts"
        :key="contact.id"
        style="
          position: relative;
          display: grid;
          grid-template-columns: minmax(33.33%, 1fr) 1fr 1fr;
          align-items: center;
          padding: 10px;
          gap: 16px;
          cursor: pointer;
          transition: background-color 0.2s;
          border-radius: 4px;
        "
        :style="{ backgroundColor: hoveredIndex === index ? 'var(--gray-6)' : 'transparent' }"
        @click="
          () => {
            selectedContactId = contact.id;
            showContactSheet = true;
          }
        "
        @mouseenter="hoveredIndex = index"
        @mouseleave="hoveredIndex = null"
      >
        <div style="grid-column: 1" class="font-medium">
          <TextEllipsis>{{ getFullName(contact) }}</TextEllipsis>
        </div>
        <div
          style="grid-column: 2; display: flex; justify-content: flex-start; align-items: center; color: var(--gray-2)"
        >
          <TextEllipsis>
            {{ contact.phone_number ? stylifyPhoneNumber(contact.phone_number) : "-" }}
          </TextEllipsis>
        </div>
        <div
          style="
            grid-column: 3;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 8px;
            color: var(--gray-2);
          "
        >
          <TextEllipsis>{{ contact.email ?? "-" }}</TextEllipsis>
          <AwIcon name="i-ph-arrow-up-right" style="flex: 0 0 auto" class="ml-1" />
        </div>
        <div
          v-if="index < displayedContacts.length - 1"
          style="position: absolute; bottom: 0; left: 0px; right: 0px; height: 1px; background-color: var(--gray-5)"
        ></div>
      </div>
      <div v-if="hasMore">
        <div style="height: 1px; background-color: var(--gray-5)"></div>
        <div style="display: flex; justify-content: center; align-items: center; padding: 4px">
          <AwButton variant="ghost" color="secondary" @click="loadMore">
            <div class="color-secondary-800">Voir plus</div>
          </AwButton>
        </div>
      </div>
    </div>
    <div
      v-else
      style="
        border: 1px dashed var(--gray-4);
        border-radius: 8px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--gray-2);
      "
    >
      {{ emptyMessage }}
    </div>
  </div>
  <div v-if="selectedContactId">
    <LazyContactSheet v-if="showContactSheet" :contact_id="selectedContactId" @on-close="showContactSheet = false" />
  </div>
</template>

<script setup lang="ts">
import { getFullName } from "@asap/shared/utils";
import type { Contact } from "@asap/shared/schemas/contact";
import { stylifyPhoneNumber } from "@asap/shared/utils/phoneNumber";

const props = defineProps<{
  contacts: Contact[];
  emptyMessage: string;
  loading?: boolean;
}>();

const INITIAL_DISPLAY = 3;
const LOAD_MORE_COUNT = 5;

const showContactSheet = ref(false);
const selectedContactId = ref<string | null>(null);

const displayedCount = ref(INITIAL_DISPLAY);
const hoveredIndex = ref<number | null>(null);

const displayedContacts = computed(() => {
  return props.contacts.slice(0, displayedCount.value);
});

const hasMore = computed(() => {
  return props.contacts.length > displayedCount.value;
});

const loadMore = () => {
  displayedCount.value = Math.min(displayedCount.value + LOAD_MORE_COUNT, props.contacts.length);
};
</script>
